import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import CheckoutMain from './CheckoutMain';
import Footer from '../../components/Footer';

const Checkout = () => {
  return (
    <>
      <HeaderSeven />

      <CheckoutMain />

      <Footer />
    </>
  );
};

export default Checkout;
